import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { AuthContext } from "../../hoc/AuthContext";
import { INPUT_CLASS_NAME } from "./constants";
import { Field } from "./components/FormFields";
import { useOfferForm } from "./hooks/useOfferForm";

export default function AddBrandForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { selectedDomain } = useContext(AuthContext);
  const formState = useOfferForm({
    brandId: id,
    selectedDomain,
    onSaved: () => navigate("/services/loyalty-offers"),
  });

  const { isEdit, form, error, fieldErrors, isSubmitting, handleFieldChange, handleImageChange, handleSubmit } = formState;

  return (
    <Layout>
      <main>
        <div className="mx-auto max-w-4xl my-2 px-4 lg:px-0">
          <div className="bg-white rounded-2xl shadow-lg">
            <div className="mx-auto p-6 bg-slate-50 rounded-t-2xl">
              <h1 className="text-2xl font-bold tracking-tight text-gray-900">
                {isEdit ? "Edit Brand" : "Add Brand"}
              </h1>
              <p className="mt-1 text-sm text-gray-600">
                {isEdit
                  ? "Update the brand details. Brand name is required."
                  : "Add a brand with its English and Hindi details. Brand name and logo are required."}
              </p>
            </div>

            <form className="space-y-8 p-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <Field
                  id="brand_name_en"
                  name="brand_name_en"
                  label="Brand Name (EN) *"
                  value={form.brand_name_en}
                  onChange={handleFieldChange}
                  placeholder="Enter brand name in English"
                  error={Boolean(fieldErrors.brand_name_en)}
                  errorMessage={fieldErrors.brand_name_en}
                />

                <div>
                  <label htmlFor="brand_logo" className="block text-sm font-semibold text-gray-900">
                    {isEdit ? "Brand Logo" : "Brand Logo *"}
                  </label>
                  <input
                    id="brand_logo"
                    name="brand_logo"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    aria-invalid={Boolean(fieldErrors.brand_logo)}
                    className={`${INPUT_CLASS_NAME} ${fieldErrors.brand_logo ? "border-red-500 focus:border-red-500 focus:ring-red-500" : ""}`}
                  />
                  {fieldErrors.brand_logo ? (
                    <p className="mt-1 text-xs text-red-600">{fieldErrors.brand_logo}</p>
                  ) : null}
                  {form.brand_logo && typeof form.brand_logo !== "string" ? (
                    <p className="mt-2 text-sm text-gray-600">Selected file: {form.brand_logo.name}</p>
                  ) : null}
                  {isEdit ? (
                    <p className="mt-2 text-xs text-gray-500">Optional while editing. Leave it empty to keep the existing logo.</p>
                  ) : null}
                </div>

                <Field
                  id="brand_tagline_en"
                  name="brand_tagline_en"
                  label="Brand Tagline (EN)"
                  value={form.brand_tagline_en}
                  onChange={handleFieldChange}
                  placeholder="Enter English tagline"
                />

                <Field
                  id="brand_name_hi"
                  name="brand_name_hi"
                  label="Brand Name (HI)"
                  value={form.brand_name_hi}
                  onChange={handleFieldChange}
                  placeholder="Enter brand name in Hindi"
                />

                <Field
                  id="brand_tagline_hi"
                  name="brand_tagline_hi"
                  label="Brand Tagline (HI)"
                  value={form.brand_tagline_hi}
                  onChange={handleFieldChange}
                  placeholder="Enter Hindi tagline"
                />
              </div>

              {/* {error ? <p className="text-sm text-red-600">{error}</p> : null} */}

              <div className="flex flex-wrap gap-2">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="inline-flex items-center rounded-xl bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600 disabled:cursor-not-allowed disabled:bg-cyan-300"
                >
                  {isSubmitting ? (isEdit ? "Saving..." : "Adding...") : isEdit ? "Save Brand" : "Add Brand"}
                </button>
                <button
                  type="button"
                  className="inline-flex items-center rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                  onClick={() => navigate("/services/loyalty-offers")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </Layout>
  );
}
